import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const DowntimeAnalysis = lazy(() => import('../../pages/reports_analytics/DowntimeAnalysis'))
const FilterAssetData = lazy(() => import('../../pages/reports_analytics/FilterAssetData'))
const AuditList = lazy(() => import('../../pages/report/audit/AuditList'))
const AuditDetails = lazy(() => import('../../pages/report/audit/AuditDetails'))
const AssetDepreciationReport = lazy(() => import('../../pages/report/asset_depreciation/AssetDepreciationReport'))
const AssetAgeReport = lazy(() => import('../../pages/report/asset_age/AssetAgeReport'))
const AssetMovementReport = lazy(() => import('../../pages/report/asset_movement/AssetMovementReport'))
const AssetsDueDisposalReport = lazy(() => import('../../pages/report/assets_due_disposal/AssetsDueDisposalReport'))
const WorkOrderSummaryReport = lazy(() => import('../../pages/report/work_order_summary/WorkOrderSummaryReport'))
const MaintenanceHistoryAssetReport = lazy(() => import('../../pages/report/maintenance_history_asset/MaintenanceHistoryAssetReport'))
const PlannedVsActualReport = lazy(() => import('../../pages/report/planned_vs_actual/PlannedVsActualReport'))
const OverdueMaintenanceReport = lazy(() => import('../../pages/report/overdue_maintenance/OverdueMaintenanceReport'))
const AmcReport = lazy(() => import('../../pages/report/amc/AmcReport'))

export const ReportRouteImport = {
    RoutesMap,
    DowntimeAnalysis,
    FilterAssetData,
    AuditList,
    AuditDetails,
    AssetDepreciationReport,
    AssetAgeReport,
    AssetMovementReport,
    AssetsDueDisposalReport,
    WorkOrderSummaryReport,
    MaintenanceHistoryAssetReport,
    PlannedVsActualReport,
    OverdueMaintenanceReport,
    AmcReport,
}
